import { render } from "./ConfiguracaoAgenteView.vue?vue&type=template&id=6cd35634&scoped=true"
import script from "./ConfiguracaoAgenteView.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoAgenteView.vue?vue&type=script&lang=js"

import "./ConfiguracaoAgenteView.vue?vue&type=style&index=0&id=6cd35634&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd35634"]])

export default __exports__